import React from 'react';
import { useBlog } from '../../context/BlogContext';
import BlogCard from '../../components/blog/BlogCard';
import SEO from '../../components/SEO';
import '../../styles/Blog.css';

export default function BlogIndex() {
  const { publishedPosts, settings } = useBlog();

  const [featured, ...rest] = publishedPosts;

  return (
    <div className="blog-index" data-header-theme="light">
      <SEO
        title={settings.blogTitle || 'Journal — Notas sobre piel y rituales'}
        description={settings.blogSubtitle || 'Notas sobre cuidado facial, ciencia de la piel y rituales por Physiology Skincare Co.'}
        path="/journal"
      />
      <header className="blog-index-header">
        <h1>{settings.blogTitle || 'The Journal'}</h1>
        <p>{settings.blogSubtitle || 'Science, movement, and the art of skin'}</p>
      </header>

      {featured && <BlogCard post={featured} featured />}

      {rest.length > 0 ? (
        <div className="blog-grid">
          {rest.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      ) : (
        !featured && <p className="blog-grid-empty">No articles found.</p>
      )}
    </div>
  );
}
